import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { CategoryType } from './types'
import {ArrowLeft} from "lucide-react";

interface NewProps {
  category: CategoryType
  communities: {
    id: string
    name: string
  }[]
}

export default function New({ category, communities }: NewProps) {
  return (
    <>
      <Head title="New category" />

        <div className="flex flex-col gap-6 p-8">
            {/* Header */}
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <Link href="/system/categories">
                        <button className="rounded-lg border border-border p-2 text-foreground hover:bg-secondary transition-colors">
                            <ArrowLeft className="h-5 w-5" />
                        </button>
                    </Link>
                    <div>
                        <h1 className="text-3xl font-bold text-foreground">Create New Category</h1>
                        <p className="text-sm text-muted-foreground">Add a new taxpayer category to the system</p>
                    </div>
                </div>
            </div>


            <Form
              category={category}
              communities={communities}
              method="post"
              action="/system/categories"
              submitText="Create Category"
            />

      </div>
    </>
  )
}
